module.exports = __webpack_public_path__ + "img/set_alpha_1.0c0c4524.png";